
import React, { useState } from 'react';
import { EnhancedCalendarView } from '@/components/calendar/EnhancedCalendarView';

const Calendar = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateSelect = (date: Date) => {
    setSelectedDate(date);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Calendar</h1>
        <p className="text-muted-foreground">
          Manage your schedule and appointments with AI-powered insights.
        </p>
      </div>
      
      <EnhancedCalendarView 
        selectedDate={selectedDate}
        onDateSelect={handleDateSelect}
      />
    </div>
  );
};

export default Calendar;
